import { createIcon } from '@chakra-ui/react';

export const ShopIcon = createIcon({
  displayName: 'ShopIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M22.3601 8.27L22.0701 5.5C21.6501 2.48 20.2801 1.25 17.3501 1.25H14.9901H13.5101H10.4701H8.99014H6.59014C3.65014 1.25 2.29014 2.48 1.86014 5.53L1.59014 8.28C1.49014 9.35 1.78014 10.39 2.41014 11.2C3.17014 12.19 4.34014 12.75 5.64014 12.75C6.90014 12.75 8.11014 12.12 8.87014 11.11C9.55014 12.12 10.7101 12.75 12.0001 12.75C13.2901 12.75 14.4201 12.15 15.1101 11.15C15.8801 12.14 17.0701 12.75 18.3101 12.75C19.6401 12.75 20.8401 12.16 21.5901 11.12C22.1901 10.32 22.4601 9.31 22.3601 8.27Z"
          fill="#6E6789"
        />
        <path
          d="M11.3501 16.66C10.0801 16.79 9.12012 17.87 9.12012 19.15V21.89C9.12012 22.16 9.34012 22.38 9.61012 22.38H14.3801C14.6501 22.38 14.8701 22.16 14.8701 21.89V19.5C14.8801 17.41 13.6501 16.42 11.3501 16.66Z"
          fill="#6E6789"
        />
        <path
          d="M21.3699 14.4V17.38C21.3699 20.14 19.1299 22.38 16.3699 22.38C16.0999 22.38 15.8799 22.16 15.8799 21.89V19.5C15.8799 18.22 15.4899 17.22 14.7299 16.54C14.0599 15.93 13.1499 15.63 12.0199 15.63C11.7699 15.63 11.5199 15.64 11.2499 15.67C9.46988 15.85 8.11988 17.35 8.11988 19.15V21.89C8.11988 22.16 7.89988 22.38 7.62988 22.38C4.86988 22.38 2.62988 20.14 2.62988 17.38V14.42C2.62988 13.72 3.31988 13.25 3.96988 13.48C4.23988 13.57 4.50988 13.64 4.78988 13.68C4.90988 13.7 5.03988 13.72 5.15988 13.72C5.31988 13.74 5.47988 13.75 5.63988 13.75C6.79988 13.75 7.93988 13.32 8.83988 12.58C9.69988 13.32 10.8199 13.75 11.9999 13.75C13.1899 13.75 14.2899 13.34 15.1499 12.6C16.0499 13.33 17.1699 13.75 18.3099 13.75C18.4899 13.75 18.6699 13.74 18.8399 13.72C18.9599 13.71 19.0699 13.7 19.1799 13.68C19.4899 13.64 19.7699 13.55 20.0499 13.46C20.6999 13.24 21.3699 13.72 21.3699 14.4Z"
          fill="#6E6789"
        />
      </svg>
    </>
  ),
});
